@if (loadingMilestoneUpdate) {
<div class="d-flex justify-content-center">
  <mat-spinner [diameter]="42"></mat-spinner>
</div>
} @if (!loadingMilestoneUpdate) {
<div class="line" [ngClass]="{ full: areAllMilestonesActive() }">
  @if (!disabled) { @for (milestone of milestones; track milestone; let i =
  $index) {
  <a
    [ngClass]="{
      active: isActive(milestone),
      hover: isMouseOver(milestone),
      loading: isLoading(milestone)
    }"
    (click)="updateMilestoneStatus(milestone.value)"
    (mouseenter)="onMilestoneMouseOver(milestone.value)"
    (mouseleave)="onMilestoneMouseLeave()"
    [ngStyle]="toPointStyle(i)"
    class="point"
  ></a>
  } } @if (disabled) { @for (milestone of milestones; track milestone; let i =
  $index) {
  <div
    [ngClass]="{
      active: isActive(milestone),
      hover: isMouseOver(milestone),
      loading: isLoading(milestone)
    }"
    [ngStyle]="toPointStyle(i)"
    (mouseenter)="onMilestoneMouseOver(milestone)"
    (mouseleave)="onMilestoneMouseLeave()"
    class="point"
  ></div>
  } }
  <div class="active-line" [ngStyle]="currentLineStyle"></div>
  <div class="point active" [ngStyle]="currentPointStyle"></div>
</div>
} @if (!loadingMilestoneUpdate) {
<div class="labels">
  @for (milestone of milestones; track milestone; let i = $index) {
  <label
    [ngClass]="{
      active: isActive(milestone),
      hover: isMouseOver(milestone),
      loading: isLoading(milestone)
    }"
    (click)="updateMilestoneStatus(milestone.value)"
    (mouseenter)="onMilestoneMouseOver(milestone.value)"
    (mouseleave)="onMilestoneMouseLeave()"
    [ngStyle]="toLabelStyle(i)"
    >{{ milestone.label }}</label
  >
  }
</div>
}
